<template>
  <b-container>
    <b-col class="mt-2">
      <div class="cardContainer">
        <template-status v-if="editMode" :status="status" />
        <b-container style="margin-bottom: 15px">
          <b-row class="text-center">
            <b-col>
              <b-button v-if="editMode" variant="primary" @click="openModal()">
                {{ $t("label_evaluation_administrator_node_new") }}
              </b-button>
            </b-col>
          </b-row>
        </b-container>
        <div v-if='!getIsLoading'>
          <h4>
            {{ evaluationData.evaluation_administrator_model_name }}
          </h4>
          <div v-if="totalPercentage !== 100" class="no-one-hundred" style="color: #b4072c">
            <div>{{$t("label_evaluation_administrator_node_statusInactive")}}</div>
            <div>{{$t("label_evaluation_administrator_node_warning_percentualWeight")}}</div>
          </div>
          <div v-else class="no-one-hundred" style="color: #28a745">
            <div>{{$t("label_evaluation_administrator_node_statusActive")}}</div>
          </div>
        </div>
        <evaluation-models-requirements-tree-list
          :last-created="lastCreated"
          :edit-mode="editMode"
          :model="data"
          default-tree-node-name="new node"
          default-leaf-node-name="new leaf"
          @drop="dataChanged"
          @drop-after="dataChanged"
          @drop-before="dataChanged"
          @click="onClick"
          @add-node="openModal"
          @dataChanged="dataChanged"
          @delete-node="dataChanged"
        />
      </div>
    </b-col>
    <div>
      <b-modal
        id="modalInfo"
        v-model="showModal"
        modal-class="modalInfo"
        :title="
          edit
            ? $t('label_evaluation_administrator_node_editRequirement_title')
            : $t('label_evaluation_administrator_node_new')
        "
      >
        <b-container>
          <b-row>
            <b-col>
              <b-form @submit.prevent="">
                <b-container>
                  <b-row>
                    <b-col cols="4">
                      <b-form-group label-class="text-sm-left">
                        <template slot="label">
                          <!--title-->
                          <span class="label">
                            {{
                              $t(
                                "label_evaluation_administrator_node_nomenclature"
                              )
                            }}</span
                          >
                        </template>
                        <b-form-input
                          id="label_evaluation_administrator_node_nomenclature"
                          v-model="
                            model.evaluation_administrator_node_nomenclature
                          "
                          :readonly="!editMode"
                          type="text"
                          required
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <form-error
                    :errors="
                      errors['evaluation_administrator_node_nomenclature']
                    "
                    :field-name="'evaluation_administrator_node_nomenclature'"
                  />
                  <b-form-group label-class="text-sm-left">
                    <template slot="label">
                      <!--title-->
                      <span class="label">
                        {{
                          $t(
                            "label_evaluation_administrator_node_requirementName"
                          )
                        }}</span
                      >
                    </template>
                    <b-form-textarea
                      id="label_evaluation_administrator_node_requirementName"
                      v-model="
                        model.evaluation_administrator_node_requirementName
                      "
                      :readonly="!editMode"
                      type="text"
                      required
                    />
                  </b-form-group>
                  <form-error
                    :errors="
                      errors['evaluation_administrator_node_requirementName']
                    "
                    :field-name="'evaluation_administrator_node_requirementName'"
                  />
                  <b-form-group label-class="text-sm-left">
                    <template slot="label">
                      <!--title-->
                      <span class="label">
                        {{
                          $t("label_evaluation_administrator_node_shortNew")
                        }}</span
                      >
                    </template>
                    <b-form-input
                      id="label_evaluation_administrator_node_shortNew"
                      v-model="model.evaluation_administrator_node_shortNew"
                      :readonly="!editMode"
                      type="text"
                      required
                    />
                  </b-form-group>
                  <form-error
                    :errors="errors['evaluation_administrator_node_shortNew']"
                    :field-name="'evaluation_administrator_node_shortNew'"
                  />
                  <b-row>
                    <b-col cols="4">
                      <b-form-group label-class="text-sm-left">
                        <template slot="label">
                          <!--title-->
                          <span class="label">
                            {{
                              $t(
                                "label_evaluation_administrator_node_percentualWeight"
                              )
                            }}</span
                          >
                        </template>
                        <b-form-input
                          id="label_evaluation_administrator_node_percentualWeight"
                          v-model="
                            model.evaluation_administrator_node_percentualWeight
                          "
                          :readonly="!editMode"
                          type="text"
                          required
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <b-form-group label-class="text-sm-left">
                        <template slot="label">
                          <!--title-->
                          <span class="label">
                            {{
                              $t(
                                "label_evaluation_administrator_node_matrix_indicator"
                              )
                            }}</span
                          >
                        </template>
                        <b-form-select
                          id="modelabel_evaluation_administrator_node_matrix_indicator"
                          v-model="
                            model.evaluation_administrator_node_matrix_indicator
                          "
                          :disabled="!editMode"
                          style="width: 100%"
                        >
                          <option :value="null" />
                          <option
                            v-for="(indicator, indicatorIndex) of indicators"
                            :key="indicatorIndex"
                            :value="indicator.indicator_acronym"
                          >
                            {{
                              $t(
                                "label_indicator_" +
                                  indicator.indicator_acronym +
                                  "_acronym"
                              )
                            }}
                            -
                            {{
                              $t(
                                "label_indicator_" +
                                  indicator.indicator_acronym +
                                  "_name"
                              )
                            }}
                          </option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <form-error
                    :errors="
                      errors['evaluation_administrator_node_percentualWeight']
                    "
                    :field-name="'evaluation_administrator_node_percentualWeight'"
                  />

                  <b-form-group
                    v-if="
                      !parent ||
                      !parent.children ||
                      parent.children.length === 0
                    "
                    label-class="text-sm-left"
                  >
                    <template slot="label">
                      <!--title-->
                      <span class="label">{{
                        $t(
                          "label_evaluation_administrator_mandatoryRequirement"
                        )
                      }}</span>
                    </template>
                    <b-container>
                      <b-row>
                        <b-col cols="4">
                          <b-form-checkbox
                            id="label_evaluation_bronze"
                            v-model="model.evaluation_bronze"
                            :disabled="!editMode"
                            class="label"
                            required
                          >
                            {{ $t("label_evaluation_bronze") }}
                          </b-form-checkbox>
                        </b-col>
                        <b-col cols="4">
                          <b-form-checkbox
                            id="label_evaluation_silver"
                            v-model="model.evaluation_silver"
                            :disabled="!editMode"
                            class="label"
                            required
                          >
                            {{ $t("label_evaluation_silver") }}
                          </b-form-checkbox>
                        </b-col>
                        <b-col cols="4">
                          <b-form-checkbox
                            id="label_evaluation_gold"
                            v-model="model.evaluation_gold"
                            :disabled="!editMode"
                            class="label"
                            required
                          >
                            {{ $t("label_evaluation_gold") }}
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-form-group>
                </b-container>
                <b-container>
                  <b-form-group label-class="text-sm-left">
                    <template slot="label">
                      <!--title-->
                      <span class="label">
                        {{
                          $t("label_evaluation_administrator_node_matrix_notes")
                        }}</span
                      >
                    </template>
                    <b-form-textarea
                      id="label_evaluation_administrator_node_matrix_notes"
                      v-model="model.evaluation_administrator_node_matrix_notes"
                      :readonly="!editMode"
                      type="text"
                      required
                    />
                  </b-form-group>
                  <b-form-group label-class="text-sm-left">
                    <template slot="label">
                      <!--title-->

                      <b-row>
                        <b-col>
                          <span class="label">
                            {{
                              $t(
                                "label_evaluation_administrator_node_editRequirement_requireEvidences_checkBox"
                              )
                            }}</span
                          >
                        </b-col>
                        <b-col>
                          <b-form-checkbox
                            id="label_evaluation_administrator_node_editRequirement_requireEvidences_checkBox"
                            v-model="
                              model.evaluation_administrator_node_editRequirement_requireEvidences
                            "
                            :disabled="!editMode"
                            type="text"
                            required
                          />
                        </b-col>
                      </b-row>
                    </template>
                  </b-form-group>
                  <b-form-group label-class="text-sm-left">
                    <template slot="label">
                      <!--title-->
                      <span class="label">
                        {{
                          $t(
                            "label_evaluation_administrator_node_editRequirement_describeEvidenceRequired"
                          )
                        }}</span
                      >
                    </template>
                    <b-form-textarea
                      id="label_evaluation_administrator_node_editRequirement_describeEvidenceRequired"
                      v-model="
                        model.evaluation_administrator_node_editRequirement_describeEvidenceRequired
                      "
                      :readonly="!editMode"
                      type="text"
                      required
                    />
                  </b-form-group>
                </b-container>
              </b-form>
            </b-col>
          </b-row>
        </b-container>
        <div slot="modal-footer" class="w-100" style="text-align: center">
          <b-row class="d-flex justify-content-center">
            <b-col cols="3">
              <b-btn @click="clearAndCloseModal">
                {{ $t("label_evaluation_cancel_button") }}
              </b-btn>
            </b-col>
            <b-col v-if="!edit" cols="3">
              <b-btn variant="primary" @click="addNode()">
                {{ $t("label_evaluation_create_button") }}
              </b-btn>
            </b-col>
            <b-col v-if="edit && editMode" cols="3">
              <b-btn variant="primary" @click="editNode()">
                {{ $t("label_evaluation_save_button") }}
              </b-btn>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </div>
  </b-container>
</template>
<script >
import { Tree, TreeNode } from "../../../../utils/vue-tree-list";
import EvaluationModelsRequirementsTreeList from "./EvaluationModelsRequirementsTreeList";
import { validateField } from "../../../../utils/commons";
import FormError from "../../../template/_template-error";
import { axiosCall } from "../../../../utils/axiosCall";
import {mapGetters} from "vuex";

export default {
  name: "EvaluationModelsRequirements",
  components: {
    FormError,
    EvaluationModelsRequirementsTreeList,
  },
  data: function () {
    return {
      totalPercentage: 0,
      errors: {},
      lastCreated: -1,
      editMode: false,
      indicators: [],
      newTree: {},
      data: new Tree([]),
      checked: false,
      modalInfo: { title: "", actionName: "", type: "", currentObject: {} },
      evaluationId: this.$route.params.evaluationId,
      evaluationData: {},
      showModal: false,
      parent: null,
      status: "success",
      validations: {
        // eslint-disable-next-line camelcase
        evaluation_administrator_node_requirementName: ["required"],
        // eslint-disable-next-line camelcase
        evaluation_administrator_node_percentualWeight: ["required", "float"],
      },
      model: {
        // eslint-disable-next-line camelcase
        evaluation_administrator_node_nomenclature: null,
        evaluation_administrator_node_requirementName: null,
        // eslint-disable-next-line camelcase
        evaluation_administrator_node_shortNew: null,
        evaluation_administrator_node_percentualWeight: null,
      },
      edit: false,
    };
  },
  computed: mapGetters([
    "getIsLoading",
  ]),
  watch: {
    model: {
      handler() {
        if (this.checked) {
          this.validateForm();
        }
      },
      deep: true,
    },
    data: {
      handler() {
        this.checkPercentage();
      },
      deep: true,
    },
  },
  async created() {
    await axiosCall({
      url: "Indicators/getAllIndicatorAcronyms",
      method: "GET",
    }).then((indicators) => {
      this.indicators = indicators.data;
    });
    await axiosCall({
      url: "EvaluationModels/getModel/" + this.evaluationId,
      method: "GET",
    }).then((response) => {
      this.evaluationData = response.data;
      if(response.isActive)
        this.evaluationData.isActive = response.isActive
      if (
        this.evaluationData.evaluation_administrator_model &&
        this.evaluationData.evaluation_administrator_model.children &&
        Array.isArray(
          this.evaluationData.evaluation_administrator_model.children
        )
      ) {
        this.data = new Tree([
          ...this.evaluationData.evaluation_administrator_model.children,
        ]);
        this.checkPercentage();
      }
      this.editMode = this.evaluationData.nEvaluations === 0;
    });
  },
  methods: {
    checkPercentage() {
      this.totalPercentage = 0;
      this.data.children.map((child) => {
        this.totalPercentage =
          this.totalPercentage +
          parseFloat(child.evaluation_administrator_node_percentualWeight);
      });
    },
    async dataChanged() {
      var data = { id: this.evaluationId, data: this.getNewTree() };
      this.status = "pending";
      await axiosCall({
        url: "EvaluationModels/saveTree",
        method: "POST",
        data,
      })
        .then(() => {
          this.status = "success";
        })
        .catch(() => {
          this.status = "error";
        });
      await this.updateModel()
    },

    async updateModel(){
      this.evaluationData.isActive = (this.totalPercentage == 100) ? true : false
      await axiosCall({
        url: "/EvaluationModels/" + this.evaluationId,
        method: "PATCH",
        data: {isActive: this.evaluationData.isActive},
      }).then(() => {
        })
        .catch(() => {
          this.status = "error";
        });
    },

    clearAndCloseModal() {
      this.showModal = false;
    },
    validateForm() {
      this.checked = true;
      this.errors = { ...{} };
      var keys = Object.keys(this.model);
      for (var i = 0; i < keys.length; i++) {
        validateField(
          keys[i],
          this.model[keys[i]],
          this.validations[keys[i]],
          this.errors
        );
      }
      var errors = Object.keys(this.errors)
        .filter((s) => this.errors[s])
        .filter((r) => this.errors[r].length > 0);
      return errors.length === 0;
    },
    openModal(node, editNode = false) {
      this.errors = { ...{} };
      this.checked = false;
      this.edit = false;
      this.parent = null;
      this.model = {
        // eslint-disable-next-line camelcase
        evaluation_administrator_node_nomenclature: null,
        evaluation_administrator_node_requirementName: null,
        // eslint-disable-next-line camelcase
        evaluation_administrator_node_shortNew: null,
        evaluation_administrator_node_percentualWeight: null,
      };
      this.showModal = true;
      this.parent = node;
      if (editNode) {
        this.edit = true;
        // eslint-disable-next-line camelcase
        this.model.evaluation_administrator_node_nomenclature =
          node.evaluation_administrator_node_nomenclature;
        // eslint-disable-next-line camelcase
        this.model.evaluation_administrator_node_requirementName =
          node.evaluation_administrator_node_requirementName;
        // eslint-disable-next-line camelcase
        this.model.evaluation_administrator_node_shortNew =
          node.evaluation_administrator_node_shortNew;
        // eslint-disable-next-line camelcase
        this.model.evaluation_administrator_node_percentualWeight =
          node.evaluation_administrator_node_percentualWeight;
        // eslint-disable-next-line camelcase
        this.model.evaluation_gold = node.evaluation_gold;
        // eslint-disable-next-line camelcase
        this.model.evaluation_silver = node.evaluation_silver;
        // eslint-disable-next-line camelcase
        this.model.evaluation_bronze = node.evaluation_bronze;
        // eslint-disable-next-line camelcase
        this.model.evaluation_administrator_node_editRequirement_requireEvidences =
          node.evaluation_administrator_node_editRequirement_requireEvidences;
        // eslint-disable-next-line camelcase
        this.model.evaluation_administrator_node_editRequirement_describeEvidenceRequired =
          node.evaluation_administrator_node_editRequirement_describeEvidenceRequired;
        // eslint-disable-next-line camelcase
        this.model.evaluation_administrator_node_matrix_notes =
          node.evaluation_administrator_node_matrix_notes;
        // eslint-disable-next-line camelcase
        this.model.evaluation_administrator_node_matrix_indicator =
          node.evaluation_administrator_node_matrix_indicator;
      }
    },
    addNode: function () {
      if (this.validateForm()) {
        // eslint-disable-next-line camelcase
        var node = new TreeNode({
          isLeaf: false,
          // eslint-disable-next-line camelcase
          evaluation_administrator_node_nomenclature:
            this.model.evaluation_administrator_node_nomenclature,
          // eslint-disable-next-line camelcase
          evaluation_administrator_node_requirementName:
            this.model.evaluation_administrator_node_requirementName,
          // eslint-disable-next-line camelcase
          evaluation_administrator_node_shortNew:
            this.model.evaluation_administrator_node_shortNew,
          // eslint-disable-next-line camelcase
          evaluation_administrator_node_percentualWeight:
            this.model.evaluation_administrator_node_percentualWeight,
          // eslint-disable-next-line camelcase
          evaluation_administrator_node_editRequirement_requireEvidences: this
            .model
            .evaluation_administrator_node_editRequirement_requireEvidences
            ? this.model
                .evaluation_administrator_node_editRequirement_requireEvidences
            : false,
          // eslint-disable-next-line camelcase
          evaluation_administrator_node_editRequirement_describeEvidenceRequired:
            this.model
              .evaluation_administrator_node_editRequirement_describeEvidenceRequired,
          // eslint-disable-next-line camelcase
          evaluation_administrator_node_matrix_notes:
            this.model.evaluation_administrator_node_matrix_notes,
          // eslint-disable-next-line camelcase
          evaluation_administrator_node_matrix_indicator:
            this.model.evaluation_administrator_node_matrix_indicator,
          // eslint-disable-next-line camelcase
          evaluation_gold: this.model.evaluation_gold,
          // eslint-disable-next-line camelcase
          evaluation_silver: this.model.evaluation_silver,
          // eslint-disable-next-line camelcase
          evaluation_bronze: this.model.evaluation_bronze,
        });
        if (!this.data.children) {
          this.data.children = [];
        }
        if (this.parent) {
          this.parent.addChildren(node);
          this.lastCreated = node.id;
        } else {
          this.data.addChildren(node);
        }
        this.clearAndCloseModal();
        this.dataChanged();
      }
    },
    editNode() {
      if (this.validateForm()) {
        // eslint-disable-next-line camelcase
        this.parent.evaluation_administrator_node_nomenclature =
          this.model.evaluation_administrator_node_nomenclature;
        // eslint-disable-next-line camelcase
        this.parent.evaluation_administrator_node_requirementName =
          this.model.evaluation_administrator_node_requirementName;
        // eslint-disable-next-line camelcase
        this.parent.evaluation_administrator_node_percentualWeight =
          this.model.evaluation_administrator_node_percentualWeight;
        // eslint-disable-next-line camelcase
        this.parent.evaluation_administrator_node_editRequirement_requireEvidences =
          this.model
            .evaluation_administrator_node_editRequirement_requireEvidences
            ? this.model
                .evaluation_administrator_node_editRequirement_requireEvidences
            : false;
        // eslint-disable-next-line camelcase
        this.parent.evaluation_administrator_node_editRequirement_describeEvidenceRequired =
          this.model.evaluation_administrator_node_editRequirement_describeEvidenceRequired;
        // eslint-disable-next-line camelcase
        this.parent.evaluation_administrator_node_matrix_notes =
          this.model.evaluation_administrator_node_matrix_notes;
        // eslint-disable-next-line camelcase
        this.parent.evaluation_administrator_node_matrix_indicator =
          this.model.evaluation_administrator_node_matrix_indicator;
        // eslint-disable-next-line camelcase
        this.parent.evaluation_gold = this.model.evaluation_gold;
        // eslint-disable-next-line camelcase
        this.parent.evaluation_silver = this.model.evaluation_silver;
        // eslint-disable-next-line camelcase
        this.parent.evaluation_bronze = this.model.evaluation_bronze;
        this.clearAndCloseModal();
        this.dataChanged();
      }
    },
    getNewTree: function () {
      var vm = this;

      function _dfs(oldNode) {
        var newNode = {};

        for (var k in oldNode) {
          if (k !== "children" && k !== "parent") {
            newNode[k] = oldNode[k];
          }
        }

        if (oldNode.children && oldNode.children.length > 0) {
          newNode.children = [];
          for (var i = 0, len = oldNode.children.length; i < len; i++) {
            newNode.children.push(_dfs(oldNode.children[i]));
          }
        }
        return newNode;
      }

      vm.newTree = _dfs(vm.data);
      return vm.newTree;
    },

    onClick() {},
  },
};
</script >

<style lang="sass" >
h4
  font-size: 1.3rem
  text-transform: uppercase
@import "../../../../assets/css/variables"

.cardContainer
  border: 1px solid #000000
  width: 100%
  padding: 30px 40px

.cardContainer h5
  text-align: center
  width: 100%

h2
  color: black
  margin: 1em 0
.label
  font-weight: bold
  font-size: 14px
.no-one-hundred
  padding-bottom: 10px
  padding-top: 10px
  text-align: center
</style >
